import * as Toast from '@radix-ui/react-toast'
import * as React from 'react'
import { onToast, ToastPayload } from './toast'

export function Toaster(): JSX.Element {
  const [toasts, setToasts] = React.useState<ToastPayload[]>([])

  React.useEffect(() => {
    return onToast((t) => setToasts((prev) => [t, ...prev]))
  }, [])

  const remove = React.useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  return (
    <Toast.Provider swipeDirection="right">
      {toasts.map((t) => (
        <Toast.Root
          key={t.id}
          defaultOpen
          duration={t.duration}
          onOpenChange={(open) => {
            if (!open) remove(t.id)
          }}
          className={[
            'pointer-events-auto w-[360px] bg-white shadow-soft border p-4 outline-none focus:outline-none transition-transform duration-300 ease-out',
            t.variant === 'success' && 'border-l-4 border-success-default',
            t.variant === 'error' && 'border-l-4 border-error-default',
            t.variant === 'warning' && 'border-l-4 border-warning-default',
            t.variant === 'default' && 'border-l-4 border-disabled',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <Toast.Title className="font-semibold mb-2 text-primaryText">{t.title}</Toast.Title>
              <Toast.Description className="text-sm text-secondaryText">{t.description}</Toast.Description>
            </div>
            <Toast.Close asChild>
              <button type="button" className="rounded p-1 text-secondaryText hover:bg-grayDark" aria-label="Lukk">
                ✕
              </button>
            </Toast.Close>
          </div>
        </Toast.Root>
      ))}

      <Toast.Viewport
        className={['fixed top-4 right-4 z-[9999]', 'flex max-h-screen w-[390px] flex-col gap-2', 'outline-none'].join(
          ' ',
        )}
      />
    </Toast.Provider>
  )
}
